import { Store } from "vuex";
import { AdobePageLoadEvent } from "./adobe-page-load";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import { AlternatePickupLocationsVisibleEvent, CancelOrderConfirmationVisibleEvent } from "@/services/analytics/events";
import { WebPageDetails } from "../models";

export class AdobeAlternatePickupLocationsVisibleEvent extends AdobePageLoadEvent {
  constructor(event: AlternatePickupLocationsVisibleEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      name: `order:checkout:select-alternate-location-start`,
      pageViews: {
        value: 1,
      },
      pageType: 'checkout',
      siteSection: 'cart',
    } as WebPageDetails);

    Object.assign(this.commerce, {
      alternateLocationStart: { value: 1 }
    })
  }
}